import React from 'react';
import { motion } from 'framer-motion';
import { daysLeft, exhibitionProgress, formatDate, getStatus } from '../../utils/exhibition';
import { easeOut } from '../../utils/motion';
import type { Creator } from '../../types/catalog';
interface ExhibitionProgressProps {
  creator: Creator;
  variant?: 'compact' | 'full';
}
export function ExhibitionProgress({
  creator,
  variant = 'full'
}: ExhibitionProgressProps) {
  const status = getStatus(creator);
  const progress = status === 'current' ? exhibitionProgress(creator) : status === 'past' ? 1 : 0;
  const left = daysLeft(creator);
  const urgent = status === 'current' && left <= 21;
  return <div data-id="element-242" data-mp="1vacrgo0ksjt1">
      {variant === 'full' && <div className="flex items-baseline justify-between gap-4 text-sm" data-id="element-243" data-mp="206tn03a3u0g5">
          <span data-id="element-244" data-mp="jt38s3p9tvss">
            {formatDate(creator.exhibitionStart)} → {formatDate(creator.exhibitionEnd, 'd MMMM yyyy')}
          </span>
          {status === 'current' && <span className={`shrink-0 font-medium ${urgent ? 'text-clay' : ''}`} data-id="element-245" data-mp="oq3daa6h2qhs">
              {left === 0 ? 'Dernier jour' : `J-${left}`}
            </span>}
        </div>}
      <div className={`${variant === 'full' ? 'mt-3 h-1.5' : 'h-1'} overflow-hidden rounded-full bg-line`} role="progressbar" aria-valuemin={0} aria-valuemax={100} aria-valuenow={Math.round(progress * 100)} aria-label="Avancement de la période d’exposition" data-id="element-246" data-mp="2htu8mc0qxmv4">
        <motion.div className={`h-full origin-left rounded-full ${urgent ? 'bg-clay' : 'bg-ink'}`} initial={{
        scaleX: 0
      }} whileInView={{
        scaleX: progress
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: easeOut,
        delay: 0.1
      }} data-id="element-247" data-mp="34q4avboju2zd" />
      </div>
    </div>;
}